import { LoadingOverlay as FoundationsLoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import CardPreviewSkeleton from 'framework-asset-preview-lib/internal/card/components/CardPreviewSkeleton';
import CarouselPreviewSkeleton from 'framework-asset-preview-lib/internal/carousel/CarouselPreviewSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LoadingOverlay({
  previewType
}) {
  if (previewType === 'popover') {
    return /*#__PURE__*/_jsx("div", {
      style: {
        height: 150
      },
      "data-test-id": "popover-loading-overlay",
      children: /*#__PURE__*/_jsx(FoundationsLoadingOverlay, {
        contextual: true,
        layout: "centered"
      })
    });
  }
  if (previewType === 'card') {
    return /*#__PURE__*/_jsx(CardPreviewSkeleton, {});
  }
  if (previewType === 'carousel') {
    return /*#__PURE__*/_jsx(CarouselPreviewSkeleton, {});
  }
  return /*#__PURE__*/_jsx(FoundationsLoadingOverlay, {
    contextual: true,
    layout: "centered"
  });
}